import dom from "../../../../../../dist/jsx-render/dom";
import { IDocumentInfo } from "../../../../../Model/IDocumentInfo";
import { DocumentList, DocumentListProps } from "../../../../DocumentList";
import { app } from "../../../../../Frame/App";

// TODO besserer Name...
export class Documents {

    public static createDocumentLists(element: HTMLElement) {

        let dcLists = element.querySelectorAll("[data-documents-list]");
        dcLists.forEach(e => {
            let dcList = e as HTMLElement;

            let columns = dcList.getAttribute("data-columns");

            let measureId: number;

            // Determine measure id - check if we are inside a .measure-item
            let measureItemParent = dcList.closest(".measure-item") as HTMLElement;
            if (measureItemParent) {
                let dataId = measureItemParent.getAttribute("data-id");

                if (dataId) {
                    let convertedMeasureId = Number(dataId);
                    if (!isNaN(convertedMeasureId)) measureId = convertedMeasureId;
                } else {
                    console.log(`document-list: Inside a measure-item, but data-id cannot be determined: '${dataId}'`);
                }
            } else {
                // Use parentId from url
                const urlParams = new URLSearchParams(window.location.search);
                const measureIdString = urlParams.get("parentId");
                if (measureIdString) {
                    measureId = Number(measureIdString);
                }
            }

            if (measureId && !isNaN(measureId) && measureId != 0) {
                $.ajax({
                    url: app.resolveUrl(`~/api/documents/getExtendedList/${measureId}`),
                    method: "GET",
                    success: (response) => {
                        let responseItems = response as IDocumentInfo[];
                        if (responseItems) {
                            let props: DocumentListProps = {
                                data: responseItems,
                                fixed: true,
                                measureId: measureId,
                                parentElement: dcList,
                                allowEdit: false,
                                columns: columns
                            };

                            let documentList = new DocumentList(props);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            }
        });

    }

}